import React from "react";
import ListGroup from "react-bootstrap/ListGroup";
import { Link } from "react-router-dom";
import "./userSideBar.css";

function UserSideBar() {
  return (
    <div>
      <ListGroup className="list text-start " variant="flush">
        <Link className="text-decoration-none " to={"/profile/orders"}>
          <ListGroup.Item className="text-decoration-none border-top-0 border-start-0 border-end-0">
            My Orders
          </ListGroup.Item>
        </Link>
        <Link className="text-decoration-none" to={"/profile/account-details"}>
          <ListGroup.Item className="border-top-0 border-start-0 border-end-0">
            Account details
          </ListGroup.Item>
        </Link>

        <Link className="text-decoration-none" to={"/profile/logout"}>
          <ListGroup.Item className="border-top-0 border-start-0 border-end-0">
            Logout
          </ListGroup.Item>
        </Link>
      </ListGroup>
    </div>
  );
}

export default UserSideBar;
